import { useNewUiContext } from '../components/NewUiProvider/NewUiProvider';

export const useIsNewUiEnabled = () => {
  const { isNewUiEnabled } = useNewUiContext();

  return isNewUiEnabled;
};
